import {Component} from '@angular/core';
import {TranslateService} from "@ngx-translate/core";
import {Language} from "../../../models/language";

@Component({
  selector: 'app-digital-business-card-sharing',
  templateUrl: './digital-business-card-sharing.component.html',
  styleUrls: ['./digital-business-card-sharing.component.scss', './digital-business-card-sharing-media.component.scss']
})
export class DigitalBusinessCardSharingComponent {
  protected readonly links = [
    {
      image: 'assets/homepage/digital-business-card-sharing/click.svg',
      title: 'home-page-content.instant_click',
      subtitle: 'home-page-content.instant_click_text'
    },
    {
      image: 'assets/homepage/digital-business-card-sharing/scan.svg',
      title: 'home-page-content.scan_connect',
      subtitle: 'home-page-content.scan_connect_text'
    },
    {
      image: 'assets/homepage/digital-business-card-sharing/link.svg',
      title: 'home-page-content.link_with_social_networks',
      subtitle: 'home-page-content.link_with_social_networks_text'
    },
    {
      image: 'assets/homepage/digital-business-card-sharing/signature.svg',
      title: 'home-page-content.signature_integration',
      subtitle: 'home-page-content.signature_integration_text'
    },
  ]

  currentLang: string = '';

  constructor(public translate: TranslateService) {
    this.translate.setDefaultLang(Language.HY);
    this.currentLang = this.translate.currentLang || Language.HY;
    this.translate.onLangChange.subscribe((event) => {
      this.currentLang = event.lang;
    });
  }

  protected readonly Language = Language;
}
